import useUser from "@/hooks/useUser"

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function freeTrialApplies<P extends {}, Q extends {}>(
  Component: React.ComponentType<P>,
  Or?: React.ComponentType<Q>,
) {
  const NewComponent = (props: P | Q) => {
    const { isFreeTrial } = useUser()
    if (isFreeTrial) {
      return <Component {...(props as P)} />
    } else if (Or) {
      return <Or {...(props as Q)} />
    } else {
      return null
    }
  }
  return NewComponent
}
